<h2 mat-dialog-title class="text-2xl md:text-5xl font-semibold tracking-tight leading-7 md:leading-snug truncate">Lugar de expedición</h2>
<div mat-dialog-content>

    <div class="flex flex-col flex-auto min-w-0">
        <div class="bg-card">
            <div class="flex flex-col min-w-0 ml-4">
                <ng-container *transloco="let t">
                </ng-container>
            </div>
            <br>
            <mat-card-content>
                <h5>Datos generales</h5>
                <form [formGroup]="lugarExpedicionForm" class="row d-flex justify-content-start align-items-center">
                    <div class="grid sm:grid-cols-4 gap-6 w-full mt-8">
                        <!-- Razón social -->
                        <div class="sm:col-span-4">
                            <mat-form-field class="fuse-mat-no-subscript w-full">
                                <mat-label>Nombre</mat-label>
                                <input [formControlName]="'nombreLugar'" matInput>
                            </mat-form-field>
                        </div>
                        <!-- Régimen fiscal -->
                        <div class="sm:col-span-4">
                            <mat-form-field class="fuse-mat-no-subscript w-full">
                                <mat-label>Descripción</mat-label>
                                <input [formControlName]="'descripcionLugar'" matInput>
                            </mat-form-field>
                        </div>

                        <!-- Folio de inicio -->
                        <div class="sm:col-span-2">
                            <mat-form-field class="fuse-mat-no-subscript w-full">
                                <mat-label>Código postal</mat-label>
                                <input [formControlName]="'CP'" (blur)="consultaSepomex()" maxlength="5" matInput>
                            </mat-form-field>
                        </div>

                        <div class="sm:col-span-4">
                            <!-- <div class="alert alert-danger" role="alert" *ngIf="respuestaCP?.error">
                                <small>Código postal incorrecto</small>
                            </div> -->

                            <div *ngIf="data?.attributes">
                                <div class="alert alert-primary" role="alert">
                                    <small>El código postal ya no es posible editarlo, si necesitas un nuevo código postal deberas
                                        agregar una nueva dirección</small>
                                </div>
                            </div>
                        </div>

                    </div>

                    <!-- Divider -->
                    <div class="my-10 border-t"></div>

                    <!-- Section -->
                    <div class="w-full">
                        <div class="text-xl">Dirección</div>

                    </div>
                    <div class="grid sm:grid-cols-4 gap-6 w-full mt-8">
                        <div class="sm:col-span-4">
                            <mat-form-field class="fuse-mat-no-subscript w-full">
                                <mat-label>Calle:</mat-label>
                                <input matInput placeholder="Calle" formControlName="calle" maxlength="30"
                                    oninput="this.value = this.value.toUpperCase()"
                                    onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122)
                                || (event.charCode >= 44 && event.charCode <= 46) || (event.charCode == 32 || event.charCode == 209 || event.charCode == 241))" />
                            </mat-form-field>
                        </div>

                        <div class="sm:col-span-2">
                            <mat-form-field class="fuse-mat-no-subscript w-full">
                                <mat-label>No. Exterior:</mat-label>
                                <input matInput placeholder="No. Exterior" formControlName="noExterior"/>
                            </mat-form-field>
                        </div>

                        <div class="sm:col-span-2">
                            <mat-form-field class="fuse-mat-no-subscript w-full">
                                <mat-label>No. Interior:</mat-label>
                                <input matInput placeholder="No. Interior" formControlName="noInterior"/>
                            </mat-form-field>
                        </div>

                        <div class="sm:col-span-4">
                            <mat-form-field class="fuse-mat-no-subscript w-full">
                                <mat-label>País:</mat-label>
                                <mat-select [panelClass]="isPaisReadOnly ? 'hidden' : ''" [ngClass]="{'disabledsel': isPaisReadOnly}" name="pais" [disabled]="true" placeholder="Seleccione" formControlName="pais"
                                    (selectionChange)="changePais()">
                                    <mat-option *ngFor="let pais of lstPais" [value]="pais.id">
                                        {{ pais.attributes.nombre }}
                                    </mat-option>
                                </mat-select>
                                <!-- <mat-error *ngIf="lugarExpedicionForm.controls['pais'].errors?.['required']"><strong>Campo
                                        Requerido</strong></mat-error> -->
                            </mat-form-field>
                        </div>

                        <div class="sm:col-span-4">
                            <mat-form-field class="fuse-mat-no-subscript w-full">
                                <mat-label>Estado: </mat-label>
                                <mat-select [panelClass]="isEstadoReadOnly ? 'hidden' : ''" [ngClass]="{'disabledsel': isEstadoReadOnly}" name="estado" placeholder="Seleccione" formControlName="estado"
                                    (selectionChange)="changeEntidad()">
                                    <mat-option *ngFor="let estado of lstEstado" [value]="estado.id">
                                        {{ estado.attributes.nombre }}
                                    </mat-option>
                                </mat-select>
                                <!-- <mat-error *ngIf="lugarExpedicionForm.controls['estado'].errors?.['required']"><strong>Campo
                                        Requerido</strong></mat-error> -->
                            </mat-form-field>
                        </div>

                        <div class="sm:col-span-4">
                            <mat-form-field class="fuse-mat-no-subscript w-full">
                                <mat-label>Municipio: </mat-label>
                                <mat-select [panelClass]="isMunicipioReadOnly ? 'hidden' : ''" [ngClass]="{'disabledsel': isMunicipioReadOnly}" name="municipio" placeholder="Seleccione" formControlName="municipio"
                                    (selectionChange)="changeMunicipio()">
                                    <mat-option *ngFor="let municipio of lstMunicipio" [value]="municipio.id">
                                        {{ municipio.attributes.nombre }}
                                    </mat-option>
                                </mat-select>
                                <!-- <mat-error *ngIf="lugarExpedicionForm.controls['municipio'].errors?.['required']">
                                    <strong>Campo
                                        Requerido</strong>
                                </mat-error> -->
                            </mat-form-field>
                        </div>

                        <div class="sm:col-span-4">
                            <mat-form-field class="fuse-mat-no-subscript w-full" *ngIf="!isColoniaManual">
                                <mat-label>Colonia: </mat-label>
                                <mat-select name="tipo" placeholder="Seleccione" formControlName="colonia">
                                    <mat-option *ngFor="let asentamiento of lstAsentamiento" [value]="asentamiento.id">
                                        {{ asentamiento.attributes.nombre }}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="lugarExpedicionForm.controls['colonia'].errors?.['required']">
                                    <strong>Campo
                                        Requerido</strong>
                                </mat-error>
                            </mat-form-field>
                            <mat-form-field class="custom-field" appearance="outline"  *ngIf="isColoniaManual">
                                <input matInput placeholder="Colonia" formControlName="coloniaManual"  minlength="1">
                            </mat-form-field>

                            <small class="floatRight" *ngIf="isColoniaManual">
                                <p class="buttoLikehref" (click)="changeVerManualmente(false);">Ver opciones</p>
                            </small>

                            <small class="floatRight" *ngIf="!isColoniaManual">
                                <p class="buttoLikehref" (click)="changeVerManualmente(true);">Ingresar manualmente</p>
                            </small>
                        </div>
                    </div>
                </form>
            </mat-card-content>
        </div>
    </div>
</div>

<div mat-dialog-actions align="end">
    <button mat-button (click)="close(0)">Cerrar</button>
    <button *ngIf="!modificarDatos" mat-flat-button color="accent" [disabled]="!lugarExpedicionForm.valid" (click)="addPlace();">Guardar</button>
    <button *ngIf="modificarDatos" mat-flat-button color="accent" [disabled]="!lugarExpedicionForm.valid" (click)="modifyPlace();">Actualizar</button>
</div>
